import React, { useCallback, useEffect } from 'react';
import useOrganizationUsers from 'src/dataHooks/useOrganizationUsers';
import { useParams } from 'react-router-dom';
import { Table } from '@1c/ui';
import PageSpin from 'src/components/PageSpin';
import ActionCell from './ActionCell';
import styles from './styles.module.scss';
import InviteUserLink from './InviteUserLink';

const getFullName = (user: any) => {
  return [user.secondName, user.firstName, user.middleName].reduce((acc, it) => {
    return it ? `${acc} ${it}` : acc;
  }, '');
};

const OrganizationUsers: React.FC = () => {
  const params = useParams();
  const {
    isOrganizationUsersLoading,
    organizationUsers,
    fetchOrganizationUsers,
  } = useOrganizationUsers();

  useEffect(() => {
    fetchOrganizationUsers(params.organizationUeid || '');
  }, [fetchOrganizationUsers, params.organizationUeid]);

  const isCurrentUserConfirmedWithSignature = !!organizationUsers?.find((user: any) => {
    return user?.currentUser;
  })?.confirmedWithSignature;

  const handleUsersChange = useCallback(() => {
    fetchOrganizationUsers(params.organizationUeid || '');
  }, [fetchOrganizationUsers]);
  
  const columns = [
    {
      Header: 'ФИО',
      style: { textAlign: 'center' },
      Cell: ({ original }: any) => getFullName(original),
      width: '100%',
    },
    {
      Header: 'Телефон',
      accessor: 'phoneNumber',
      style: { textAlign: 'center' },
      width: '100%',
    },
    {
      Header: 'E-mail',
      accessor: 'email',
      style: { textAlign: 'center' },
      width: '100%',
    },
    {
      Header: 'Действие',
      style: { textAlign: 'center' },
      width: '100%',
      Cell: ({ original }: { original: any }) => (
        <ActionCell
          organizationUser={original}
          isCurrentUserConfirmedWithSignature={isCurrentUserConfirmedWithSignature}
          handleUsersChange={handleUsersChange}
        />
      ),
    },
  ];

  if (isOrganizationUsersLoading) {
    return <PageSpin />;
  }

  const tableData = organizationUsers ?? [];

  return (
    <div>
      <div className={styles['add-user-link-wrapper']}>
        <InviteUserLink />
      </div>
      <Table
        columns={columns}
        data={tableData}
        noDataText="Нет данных"
        sortable={false}
        resizable={false}
        showPagination={false}
        pageSize={tableData.length}
      />
    </div>
  );
};

export default OrganizationUsers;
